"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoyaltyBehaviorBase = void 0;
class LoyaltyBehaviorBase {
    showsInternalLoyalty(canAccessLoyalty) {
        return this.capabilities.showsInternalLoyaltyData && canAccessLoyalty;
    }
    getCustomerProfileConfig({ canAccessLoyalty, result, }) {
        const internal = this.showsInternalLoyalty(canAccessLoyalty);
        const readSucceeded = result.status !== 'error';
        return {
            // No balance until we know they are enrolled, but a failed read keeps the row
            // so it can host the retry.
            showLoyaltyBalance: this.capabilities.usesProviderPoints
                ? !readSucceeded || result.status === 'enrolled'
                : internal,
            showLoyaltyGroup: internal,
            showLoyaltyLogs: internal,
            useProviderPoints: this.capabilities.usesProviderPoints,
            showPointsRetry: this.capabilities.supportsPointsRetry,
            // Enrollment state is only actionable once the read told us what it is.
            showEnrollmentToggle: this.capabilities.supportsEnrollment && readSucceeded,
        };
    }
    getCustomerListConfig(canAccessLoyalty) {
        return {
            showInternalLoyaltyInfo: this.showsInternalLoyalty(canAccessLoyalty),
        };
    }
    getSaleCustomerConfig(canAccessLoyalty) {
        const internal = this.showsInternalLoyalty(canAccessLoyalty);
        return {
            showLoyaltyBalance: this.capabilities.usesProviderPoints || internal,
            showLoyaltyGroup: internal,
            useProviderPoints: this.capabilities.usesProviderPoints,
        };
    }
}
exports.LoyaltyBehaviorBase = LoyaltyBehaviorBase;
//# sourceMappingURL=base.js.map